import { render, staticRenderFns } from "./AbsenceReport.vue?vue&type=template&id=2a2b87b6&"
import script from "./AbsenceReport.vue?vue&type=script&lang=js&"
export * from "./AbsenceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports